<div *ngIf="!isUserAuthenticated" class="auth-wrapper">
  <nb-card class="login-container">
    <nb-card-header>
      <h2>Paso 1: Registro e Inicio de Sesión</h2>
    </nb-card-header>
    <nb-card-body>
      <p class="auth-message">
        Por favor, regístrate o inicia sesión para continuar con el registro de la {{entidad_label}}.
      </p>
      <div id="register-firebaseui-auth-container"></div>
    </nb-card-body>
  </nb-card>
</div>

<div *ngIf="isUserAuthenticated && !isEmailVerified" class="auth-wrapper">
  <nb-card class="login-container">
    <nb-card-header>
      <h2>Paso 1: Verificación de Email</h2>
    </nb-card-header>
    <nb-card-body>
      <nb-alert status="info" closable="false">
        <p class="auth-message verification-message">
          ✓ Hemos enviado un correo a <strong>{{ currentUserEmail }}</strong> para verificar que es una cuenta válida.
        </p>
        <p class="auth-subtext">
          Por favor, revisa tu bandeja de entrada (y la carpeta de spam) y haz clic en el enlace de verificación. Una vez verificado, podrás continuar con el registro de tu entidad.
        </p>
      </nb-alert>
    </nb-card-body>
  </nb-card>
</div>

<nb-card class="register-container" *ngIf="isUserAuthenticated && isEmailVerified">
  <nb-card-header><h2>{{ titulo }}</h2></nb-card-header>

  <nb-card-body
    [nbSpinner]="loading"
    nbSpinnerStatus="danger"
    nbSpinnerMessage="Creando entidad...">

    <div class="scrollable-content">
    <form>

      <div class="form-group">
        <label>Nombre de la {{entidad_label}}</label>
        <input nbInput fullWidth [(ngModel)]="entidad.name" name="name">
      </div>

      <div class="form-group">

        <div class="label-with-info">
          <label>Tamaño</label>

          <button
            nbButton
            ghost
            size="tiny"
            status="basic"
            nbPopover
            nbPopoverPlacement="right"
            [nbPopover]="sizeInfo">
            <nb-icon icon="info-outline"></nb-icon>
          </button>
        </div>

        <nb-select
            fullWidth
            name="size"
            placeholder="Seleccione un tamaño"
            [(ngModel)]="entidad.size">

            <nb-option
                *ngFor="let item of typeSize"
                [value]="item.identifier">
                {{ item.name }}
            </nb-option>

        </nb-select>

      </div>

      <ng-template #sizeInfo>
        <div *ngIf="tipoRegistro === 'ENTITY'" class="size-info">
          <div><strong>Pequeña:</strong> Hasta 25 explotaciones</div>
          <div><strong>Mediana:</strong> Hasta 100 explotaciones</div>
          <div><strong>Grande:</strong> Más de 100 explotaciones</div>
        </div>
        <div *ngIf="tipoRegistro === 'COMPANY'" class="size-info">
          <div><strong>Unipersonal:</strong> Una sola explotación sin trabajadores</div>
          <div><strong>Simple:</strong> Hasta 5 explotaciones con trabjadores</div>
          <div><strong>Empresa:</strong> Más de 5 explotaciones con trabajadores</div>
        </div>
      </ng-template>

      <div class="form-group" *ngIf="titularRegistrado === true  && entidad.size == 'company_xs'" >
        <label>Ya existe un titular registrado con el email proporcionado en Visor SIGPAC. Su cuenta de VisorCUE se asociará a dicho titular. Para poder operar en VisorCUE recuerde que debe autorizar a AIDIAPP a acceder a sus datos del REA (Registro de Explotaciones Agrícolas) de su comunidad autónoma.</label>
      </div>

      <div class="form-group" *ngIf="titularRegistrado === false && entidad.size == 'company_xs'" >
        <label>No existe ningún titular registrado con el email proporcionado en Visor SIGPAC. Se creará un nuevo titular de explotación con los datos proporcionados y su cuenta de VisorCUE se asociará a dicho titular. Para poder operar en VisorCUE recuerde que debe autorizar a AIDIAPP a acceder a los datos del REA (Registro de Explotaciones Agrícolas) de su comunidad autónoma.</label>
      </div>

      <div class="form-group">
        <label>Dirección</label>
        <input nbInput fullWidth [(ngModel)]="entidad.postalAddress" name="postalAddress">
      </div>

      <div class="form-group">
        <label>Código Postal</label>
        <input
            nbInput
            fullWidth
            name="postalCode"
            [(ngModel)]="entidad.postalCode"
            pattern="^[0-9]{5}$"
            #cp="ngModel"
            placeholder="Código Postal"
            />

            <nb-error *ngIf="cp.invalid && cp.touched">
            El código postal debe tener 5 dígitos
            </nb-error>
      </div>


      <div class="form-group">
        <label>Ciudad</label>
        <input nbInput fullWidth [(ngModel)]="entidad.city" name="city">
      </div>

      <div class="form-group">
        <label>Provincia</label>
        <input nbInput fullWidth [(ngModel)]="entidad.province" name="province">
      </div>

      <div class="form-group">
        <label>Comunidad Autónoma</label>
        <nb-select
            fullWidth
            placeholder="Selecciona una comunidad"
            [(ngModel)]="entidad.codCA"
            name="codCA">

            <nb-option
            *ngFor="let comunidad of comunidades"
            [value]="comunidad.identifier">
            {{ comunidad.name }}
            </nb-option>

        </nb-select>
      </div>

      <div class="form-group">
        <label>CIF/ NIF / NIE</label>
        <input
            nbInput
            fullWidth
            name="cif"
            [(ngModel)]="entidad.cif"
            (blur)="cifTouched = true"
            placeholder="CIF / NIF / NIE"
            />

            <nb-error *ngIf="cifTouched && !validarIdentificacion(entidad.cif)">
            CIF / NIF / NIE no válido
            </nb-error>
      </div>

      <div class="form-group terms-checkbox">
        <nb-checkbox
          [(ngModel)]="acceptedTerms"
          name="acceptedTerms"
          status="danger">
          Acepto las
          <a href="javascript:void(0)" (click)="openTermsModal()">condiciones de uso</a>
        </nb-checkbox>
      </div>

    </form>
    </div>
  </nb-card-body>

  <nb-card-footer>
    <button nbButton shape="round" status="danger" size="small" (click)="close()" style="margin-right: 8px;">Cancelar</button>
    <button nbButton shape="round" status="success" size="small" (click)="saveEntidad()" [disabled]="!acceptedTerms">Registrar</button>
  </nb-card-footer>
</nb-card>

